import { SxProps, Theme } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';

interface BlueSkeletonProps {
    height?: number | string;
    width: number | string;
    sx?: SxProps<Theme>;
    variant?: "text" | "rectangular" | "circular" | undefined;
}

const BlueSkeleton = ({ width, sx, height, variant }: BlueSkeletonProps) => {
    return (
        <Skeleton animation="wave"
            variant={variant} width={width} height={height ? height : ''}
            sx={{
                ...sx,
                bgcolor: 'rgba(2, 117, 216, 0.1)',
                borderRadius: 2
            }}
        />
    )
};

export default BlueSkeleton;